import { Component } from '@angular/core';

@Component({
  selector: 'rezolve-navbar-item',
  templateUrl: './navbar-item.component.html',
  styleUrls: ['./navbar-item.component.scss'],
})
export class NavbarItemComponent {}
